import { TagContainer } from 'src/components/Tag/Tag.styles';
import React from 'react';

interface IDocumentTag {
  color?: any;
  className?: string;
  isFromMvpApp?: boolean;
  children?: React.ReactNode;
}

export const DocumentTag = ({
  color,
  className,
  isFromMvpApp,
  children,
}: IDocumentTag) => {
  return (
    <TagContainer
      isFromMvpApp={isFromMvpApp}
      className={className}
      color={color}
    >
      {children}
    </TagContainer>
  );
};
